const faqs = [
    {
        id: 1,
        heading: 'How can I order your teas online?',
        content: 'Browse our tea collection, add your favorites to the cart, and proceed to checkout. Enter your shipping details and choose a secure payment method to complete your order.',
    },
    {
        id: 2,
        heading: 'Can I place an order anytime?',
        content: 'Yes, our online tea store is open 24/7. Orders placed during weekends or holidays will be processed on the next business day.',
    },
    {
        id: 3,
        heading: 'What happens if a tea is out of stock?',
        content: 'If a tea is unavailable, the product page will display an out-of-stock message. You can sign up for restock alerts or explore similar blends in our collection.',
    },
    {
        id: 4,
        heading: 'Do you offer discount coupons?',
        content: 'Yes, you can use valid coupon codes during checkout to enjoy special discounts. Be sure the coupon is still valid and meets any listed conditions.',
    },
    {
        id: 5,
        heading: 'What payment options do you support?',
        content: 'We accept credit/debit cards, digital wallets, and bank transfers. All payments are encrypted and processed securely to protect your information.',
    },
];

export default faqs;